// Readable "price tag" marker: the discount is drawn INTO the pin as large white text.
export const dealPinIcon = ({ discount, soon, count, boosted, lead }) => {
  const g = window.google;
  if (!g) return undefined;
  const text = discount > 0 ? `${discount}%` : "•";
  const many = count > 1;
  const pad = 5;
  const pillH = lead ? 38 : 32;
  const pillW = Math.max(lead ? 50 : 42, (lead ? 22 : 18) + text.length * (lead ? 13 : 11));
  const tail = 10;
  const extra = many ? 13 : 0;
  const W = pillW + pad * 2 + extra;
  const H = pillH + tail + pad * 2;
  const cx = pad + pillW / 2;
  const top = soon ? "#ef4444" : "#22c55e";
  const bot = soon ? "#b91c1c" : "#0e7a3c";
  // Paid placement reads as a gold-rimmed pin so it stands out without faking a bigger discount.
  const ring = boosted ? "#f5b942" : "#ffffff";
  const ringW = lead ? 4.2 : boosted ? 3.4 : 2.5;
  const fontSize = lead ? 18 : 15;
  const bY = pad + pillH - 2;
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${W}" height="${H}" viewBox="0 0 ${W} ${H}">
<defs><linearGradient id="a" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="${top}"/><stop offset="1" stop-color="${bot}"/></linearGradient>
<filter id="s" x="-60%" y="-60%" width="240%" height="240%"><feDropShadow dx="0" dy="2.5" stdDeviation="2.2" flood-color="#0f172a" flood-opacity="0.38"/></filter></defs>
<g filter="url(#s)"><path d="M${cx - 8} ${bY - 4} L${cx} ${bY + tail} L${cx + 8} ${bY - 4} Z" fill="${bot}" stroke="${ring}" stroke-width="${ringW}" stroke-linejoin="round"/>
<rect x="${pad}" y="${pad}" width="${pillW}" height="${pillH}" rx="${pillH / 2}" fill="url(#a)" stroke="${ring}" stroke-width="${ringW}"/></g>
<text x="${cx}" y="${pad + pillH / 2}" text-anchor="middle" dominant-baseline="central" font-family="Arial,Helvetica,sans-serif" font-size="${fontSize}" font-weight="bold" fill="#ffffff" letter-spacing="-0.3">${text}</text>
${many ? `<g><circle cx="${pad + pillW + 1}" cy="${pad + 5}" r="9.5" fill="#ffffff" stroke="${bot}" stroke-width="2"/><text x="${pad + pillW + 1}" y="${pad + 5}" text-anchor="middle" dominant-baseline="central" font-family="Arial,Helvetica,sans-serif" font-size="11" font-weight="bold" fill="${bot}">${count > 9 ? "9+" : count}</text></g>` : ""}
</svg>`;
  return {
    url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`,
    scaledSize: new g.maps.Size(W, H),
    anchor: new g.maps.Point(cx, H - pad),
  };
};

export const SOON_MS = 24 * 3600 * 1000;
export const pinEndsSoon = (p) => !!p.expiresAt && new Date(p.expiresAt).getTime() - Date.now() < SOON_MS;
export const pinBoosted = (p) => !!p.boostedUntil && new Date(p.boostedUntil).getTime() > Date.now();
